import { render, staticRenderFns } from "./user_home.vue?vue&type=template&id=0a89c333&scoped=true&"
import script from "./user_home.vue?vue&type=script&lang=js&"
export * from "./user_home.vue?vue&type=script&lang=js&"
import style0 from "./user_home.vue?vue&type=style&index=0&id=0a89c333&lang=scss&scoped=true&"
import style1 from "./user_home.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./user_home.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./user_home.vue?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a89c333",
  null
  
)

export default component.exports